import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import VendorBillListPageUI from './VendorBillListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

class VendorBillListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      billList: null,
      filteredBillList: null,
      createBillMode: false,
      searchFilter: ''
    }
  }

  render() {
    return (
      <VendorBillListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        billList={this.props.billList}
        filteredBillList={this.state.filteredBillList}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onSearchFilterChange={this.onSearchFilterChange}
        // create modal
        createBillMode={this.state.createBillMode}
        onCreateBillClick={(event) => { this.setState({createBillMode: true}) }}
        onCancelCreateBill={(event) => { this.setState({createBillMode: false}) }}
        onCreateBillComplete={this.onCreateBillComplete}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getVendorBills(context)
    this.getMessages(context)
  }

  getVendorBills(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/bills`,
      cacheKey: CacheKeys.Bills(context.session.accountId, ''),
      callback: this.getVendorBillsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getVendorBillsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.VendorBillsFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      billList: response.billList,
      filteredBillList: response.billList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.billList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(billList, searchFilter) {
    let filteredList = billList

    if (searchFilter)
      filteredList = filteredList.filter(bill =>
        bill.billName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        bill.vendorName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({filteredBillList: filteredList})

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.VendorBillsFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    let filter = ''
    if (! context.permissions.includes('acc_manage')) {
      filter = context.session.userId
    }
    CacheManager.removeObject(CacheKeys.Bills(context.session.accountId, filter))
    this.setState({
      errorList: null,
      billList: null,
      filteredBillList: null,
    }, () => {
      this.getVendorBills(context)
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.props.billList, searchFilter)
  }

  onCreateBillComplete = (bill) => {
    CacheManager.removeObject(CacheKeys.Bills(bill.vendorBillId))
    this.setState({ bill: bill })
    setTimeout(() => {
      this.setState({ createBillMode: false })
      this.props.history.push(`/vendorBills/${bill.customerBillId}`)
    }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_refresh', //done
      'c_create_bill',
      'c_no_bill_msg',
      'c_bill_total',
      'c_payments',
      'c_last_sent',
      'c_status_unpaid',
      'c_status_paid',
      'c_cancelled',
      'c_items',
      'c_budgets',
      'c_vendor_bills',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_ord_invs', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(VendorBillListPageSF)
